import { memo, useCallback } from 'react';
import { Grid } from 'components/ui';
import { IndexListItemButton } from 'components/styles_components/list';
import { CardTitleTypography } from 'components/styles_components/typography';
import { ArrowForwardIcon } from 'components/uiIcons';
import Role from 'components/role';

const ListItem = ({ space, onSelect }) => {
  const handleClick = useCallback(() => {
    onSelect(space);
  }, [onSelect, space]);

  return (
    <IndexListItemButton onClick={handleClick} className="bordered">
      <Grid container spacing={2}>
        <Grid size={{ xs: 11 }}>
          <CardTitleTypography>{space.name}</CardTitleTypography>
          <Role role={space.role} />
        </Grid>
        <Grid
          size={{ xs: 1 }}
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}
        >
          <ArrowForwardIcon />
        </Grid>
      </Grid>
    </IndexListItemButton>
  );
};

export default memo(ListItem);
